module.exports = __webpack_public_path__ + "static/media/project-management.17db171d.png";